import _ from 'lodash';
import React, { Fragment, Component } from 'react';
import { toast } from 'react-toastify';

import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone';
import autobind from 'autobind-decorator';
import ProgressBar from '@ramonak/react-progress-bar';


// const PROGRESSBAR_OPTS = {
// 	color: '#aaa',
// 	// This has to be the same size as the maximum width to
// 	// prevent clipping
// 	strokeWidth: 4,
// 	trailWidth: 1,
// 	easing: 'easeInOut',
// 	duration: 1400,

// 	text: {
// 		autoStyleContainer: false,
// 		style: {
// 			position: 'absolute',
// 	        left: '0',
// 	        top: '35%',
// 			width: '100%',
// 			textAlign: 'center',
// 			fontSize: '2rem',
// 			fontFamily: '"Museo Sans 100", Helvetica, sans-serif'
// 		}
// 	},
// 	from: {
// 		color: '#aaa',
// 		width: 1
// 	},
// 	to: {
// 		color: '#36ac3b',
// 		width: 4
// 	},

// 	// Set default step function for all animate calls
// 	step: (state, circle) => {
// 		circle.path.setAttribute('stroke', state.color);
// 		circle.path.setAttribute('stroke-width', state.width);

// 		const value = Math.round(circle.value() * 100);

// 		if (value === 0) {

// 			circle.setText('');
// 		} else {

// 			circle.setText(`${value}%`);
// 		}
// 	}
// };

@inject('songsStore')
@observer
class SongUpload extends Component {
	constructor (props) {
		super(props);
	}

	componentDidMount () {
		// this.props.songsStore.currentUploadProgress = 0;
	}

	render () {
		const {
			songsStore,
			onDrop = this.onDrop,
			fullWidth = false
		} = this.props;

		if (songsStore.isUpLoading) {

			console.log(songsStore.currentUploadProgress < 100 ? "Uploading Track..." : "Finishing up...", ":", songsStore.currentUploadProgress);

			return (
				<div className="grid-x align-center">
					<div className="cell padding-top-2">
						{/* <div className="loading-spinner large dark">
							<div></div>
						</div> */}
						<div style={{fontSize:'1.15em'}}>
							{songsStore.currentUploadProgress < 100 ? "Uploading Track..." : "Finishing up..."}
						</div>
						<ProgressBar completed={songsStore.currentUploadProgress}
							baseBgColor="#c1c1c1"
							bgcolor="#6f3c8a"
							labelAlignment="center"
							isLabelVisible={false}
						/>
					</div>
				</div>
			);
		}

		return (
					<Dropzone
						accept="audio/wav"
						onDrop={ onDrop }
						multiple={false}
					>
						{
							({getRootProps, getInputProps}) => (
								<section>
									<div
										{
											...getRootProps({
												className: `drop-zone${ fullWidth ? ' full-width' : '' }`
											})
										}
									>
										<input {...getInputProps()} />
										<span className="icon fi-music"></span>
										<br />
										<strong>
											Click here to select a file
											<br />
											or drag and drop one here (.wav files only).
										</strong>
									</div>
								</section>
							)
						}
					</Dropzone>
		);
	}

	@autobind
	async onDrop (files) {
		const { songsStore, artist, onUpload = () => {} } = this.props;
		
		if(files.length === 0) {
			toast.error(`File type is unsupported. Please upload a .wav file.`);
			return;
		}

		try {
			const [ newSong ] = await songsStore.uploadSongs(files, artist);
			
			if (_.isFunction(onUpload)) onUpload(newSong);
		} catch (error) {
			toast.error(`Failed to upload song: ${error.message}`);
		}
	}
}

export default SongUpload;
